import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue";
import { AnalisarReprogramacaoService } from "../../../../services/AnalisarReprogramacaoService";
import { tipoReprogramacaoEnum } from "../../../../constants/index.js";

export default {
  name: "AnalisarAlteracao",

  components: {
    SelectField,
    PeriodoField,
    TextAreaField,
  },

  props: {
    selected: {
      type: Number,
      required: true,
      default: null,
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  data: () => ({
    id: null,
    idAnalisarAlteracao: null,

    form: {},
    options: {},

    loading: {
      field: false,
      btnApprove: false,
      btnRefuse: false,
    },

    justificativaDialog: false,
    justificativaRecusa: null,
  }),

  mounted() {
    this.id = this.selected;
 


  },

  watch: {
    isOpen: function (isOpen) {
      this.id = this.selected;
      if (isOpen) {
        this.getData(this.id);
      }
    },
    id: function (id) {
      this.getData(id);
    }
  },

  computed: {
    enumtipoReprogramacao() {
      return tipoReprogramacaoEnum;
    }
  },

  methods: {
    async getData(id) {
      this.loading.field = true;
      const response = await AnalisarReprogramacaoService.getById(id);

      this.idAnalisarAlteracao = response.id;

      this.form = {
        perfilSolicitante: response.responsavel,
        dataInicioAnterior: response.ferias?.data_ini,
        dataFimAnterior: response.ferias?.data_fin,
        dataInicioAlterado: response.data_ini,
        dataFimAlterado: response.data_fin,
        tipoReprogramacao: response.tipo_alteracoes?.id.toString(16),
        anexo: response.caminho,
      };

      this.$forceUpdate();

      this.loading.field = false;
    },

    openPDF(path) {
      window.open(path);
    },

    async approve(id) {
      this.loading.btnApprove = true;
      const response = await AnalisarReprogramacaoService.aprovarAlteracao(id);
      this.loading.btnApprove = false;
      this.$emit('on-confirm');
      if (response) {
        this.close();
      }
    },

    async refuse(id) {
      const formData = new FormData();
      formData.append("justificativa_recusa", this.justificativaRecusa);
      formData.append("id_ferias", this.id);


      this.loading.btnRefuse = true;
      const response = await AnalisarReprogramacaoService.recusarAlteracao(id, formData);
      this.loading.btnRefuse = false;
      this.$emit('on-confirm');
      if (response) {
        this.justificativaDialog = false;
        this.close();
      }
    },

    close() {
      this.id = null;
      this.$emit("on-close");
    },
  },
};